import Link from "next/link"
import style from "./link_button.module.css"

const LinkButton = (param : {
    href : string,
    name : string
}) => {

    const {href, name} = param;

    return <>
    <Link className={style.link} href={href}>{name}</Link>
    </>
}

export default LinkButton